/**
 * @desc 分页列表查询
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<
  defs.basics.IPage<defs.basics.FreshdeskDataReportManagePageResponseDto>
>;
export function request(
  body: defs.basics.FreshdeskDataReportManagePageListRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/freshdeskDataReportManage/pageList`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
